import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailSenderSelectorDialogComponent } from './mail-sender-selector-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { OrganizationService } from '../../../../services/organization/organization.service';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
    ],
    declarations: [MailSenderSelectorDialogComponent],
    exports: [MailSenderSelectorDialogComponent],
    providers: [
        OrganizationService,
    ],
})
export class MailSenderSelectorDialogModule
{
}
